<template>
  <ResponsiveDropdown
    v-if="actions.length > 0"
    :title="$t('tooltips.buttons.dots_menu')"
    :items="actions"
    align="end"
    @click="(event) => event()"
  >
    <IconButton variant="tertiary" type="gray" :size="size">
      <Icon name="dots-vertical" />
    </IconButton>
  </ResponsiveDropdown>
</template>

<script setup>
import { computed } from "vue";
import { IconButton } from "@/SharedComponents/Buttons";
import { ResponsiveDropdown } from "@/SharedComponents/Dropdown";
import { Icon } from "@/SharedComponents/Icon";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["preview", "download", "unlink"]);

const props = defineProps({
  file: { type: Object, required: true },
  preview: { type: Boolean, required: false },
  size: { type: String, required: false },
  canUpdate: { type: Boolean, required: false },
});

const { t } = useI18n();

const actions = computed(() => {
  const actions = [];
  if (props.preview) {
    actions.push({
      id: "preview",
      icon: "eye-visible",
      label: t("components.buttons.preview"),
      event: () => emit("preview"),
    });
  }
  if (props.file.urls?.download) {
    actions.push({
      id: "download",
      icon: "download",
      label: t("components.buttons.download"),
      event: () => emit("download", props.file.urls.download),
    });
  }
  if (props.canUpdate) {
    actions.push({
      id: "unlink",
      icon: "link-broken",
      label: t("components.buttons.unlink"),
      variant: "primary",
      type: "destructive",
      event: () => emit("unlink"),
    });
  }
  return actions;
});
</script>
